import React from 'react';
import { Link } from 'react-router-dom';
import { Reveal } from '@/components/site/Reveal';
import { SectionLabel } from '@/components/site/SectionLabel';
import { DuotoneImage } from '@/components/site/DuotoneImage';
import { CITIES } from '@/data/cities';

/**
 * Image cards linking to the city landing pages. Doubles as the main
 * internal-link path into /website-development-company-<city>.
 */
export function CityStrip({ num = '04', className = '' }) {
  return (
    <section data-testid="city-strip" className={`relative py-24 md:py-32 border-t border-white/10 ${className}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionLabel num={num}>Where we work</SectionLabel>
        <h2 className="mt-6 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05] max-w-3xl text-balance">
          Built in Pune. Shipping for <span className="italic text-electric">Mumbai, Thane and Nashik</span> too.
        </h2>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CITIES.map((c, i) => (
            <Reveal key={c.slug} delay={i * 90}>
              <Link
                to={`${c.path}/`}
                data-testid={`city-card-${c.slug}`}
                className="group relative block aspect-[4/5] md:aspect-[3/4] overflow-hidden rounded-[20px] border border-white/[0.12] transition-all duration-500 hover:-translate-y-1 hover:border-white/25"
              >
                <DuotoneImage src={c.image.src} alt={c.image.alt} duotone={0.4} className="transition-transform duration-700 group-hover:scale-[1.03]" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-bg/90 via-ink-bg/20 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <div className="text-[10px] uppercase tracking-[0.28em] text-white/70">0{i + 1} / 0{CITIES.length}</div>
                  <h3 className="mt-2 text-3xl font-bold tracking-tight text-white">{c.name}</h3>
                  <span className="arrow-link mt-3 inline-flex items-center gap-2 text-sm text-white/85">
                    Web & app development in {c.name} <span className="arrow">→</span>
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
